module.exports = __webpack_public_path__ + "static/media/concept.3dadb4d9.svg";